import ReactDom from 'react-dom';

import styled from '@emotion/styled';

import { ModalProvider } from '../../context/ModalContext';

interface IModal {
  children: React.ReactNode;
  showModal: boolean;
  setShowModal: (...args: any) => void;
}

export const Modal: React.FC<IModal> = ({
  children,
  showModal,
  setShowModal,
}) => {
  const modalRoot = document.getElementById('modal-root');

  if (!showModal) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      setShowModal(false);
    }
  };

  return ReactDom.createPortal(
    <ModalBackdrop onClick={handleBackdropClick}>
      <ModalProvider showModal={showModal} setShowModal={setShowModal}>
        {children}
      </ModalProvider>
    </ModalBackdrop>,
    modalRoot!,
  );
};

const ModalBackdrop = styled.div`
  position: fixed;
  overflow: auto;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  isolation: isolate;
  background: rgba(142, 125, 125, 0.448);
  display: grid;
  justify-content: center;
  z-index: 1000;

  @media (max-width: 884px) {
    place-items: center;
    justify-content: normal;
    width: 100vw;
  }

  & > * {
    height: fit-content;
  }
`;
